import { CrudModel } from "./_crud";

class MonthlyCalendarAdminModel extends CrudModel {
	constructor() {
		super("admin/monthly_calendar");
	}
}

export default new MonthlyCalendarAdminModel();
